<template>

  <div class="electricity-statistics">
    <div style="width:98%;margin:25px auto">
      <!-- <el-input class="power" v-model="input" placeholder="请输入塘口"></el-input> -->
      <el-select v-model="select" slot="prepend" placeholder="全部">
        <el-option label="200mg/l" value="1"></el-option>
        <el-option label="400mg/l" value="2"></el-option>
        <el-option label="600mg/l" value="3"></el-option>
      </el-select>
      <span class="demonstration">时间</span>
      <el-date-picker
        v-model="value1"
        type="date"
        placeholder="选择日期">
      </el-date-picker>
      <span class="spr-line"></span>
      <el-date-picker
        v-model="value1"
        type="date"
        placeholder="选择日期">
      </el-date-picker>
      <el-button type="primary">查询</el-button>
    </div>
    <div ref="electricity" id="electricity" class="electricity" style="height:60vh;width:98%;margin:25px auto;overflow:hidden;"></div>
  </div>
</template>

<script>
export default {
  name: 'ElectricityStatistics',
  data () {
    return {
      input: '',
      select: '',
      value1: ''
    }
  },
  mounted () {
    this.tempauure()
  },
  methods: {
    tempauure () {
    // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(this.$refs.electricity)
      myChart.setOption({
        backgroundColor: 'rgba(175,201,255,.1)', // 背景色
        title: { // 标题
          left: 'center',
          top: 15,
          text: '帝都塘口',
          textStyle: {
            color: '#BBD4E9',
            fontWeight: 'normal'
          }
        },
        grid: { // 布局
          top: '12%',
          x: 80,
          y: 45,
          x2: 40,
          y2: 50,
          borderWidth: 1
        },
        xAxis: {
          type: 'category',
          data: ['06-20', '06-21', '06-22', '06-23', '06-24', '06-25', '06-27'],
          splitLine: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#BBD4E9'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#07f',
              width: 1 // 这里是为了突出显示加上的
            }
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false
          },
          axisLabel: {
            formatter: '{value}',
            textStyle: {
              color: '#BBD4E9'
            }
          },
          // 设置轴线的属性
          axisLine: {
            lineStyle: {
              color: '#07f',
              width: 1 // 这里是为了突出显示加上的
            }
          }
        },
        series: [
          {
            name: '邮件营销',
            type: 'line',
            stack: '总量',
            itemStyle: {
              normal: {
                lineStyle: {
                  color: '#FF4889'
                }
              }
            },
            data: [0, 132, 101, 134, 90, 230, 210]
          },
          {
            name: '视频广告',
            type: 'line',
            stack: '总量',
            itemStyle: {
              normal: {
                lineStyle: {
                  color: '#28D3FF'
                }
              }
            },
            data: [150, 232, 201, 154, 190, 330, 410]
          },
          {
            name: '直接访问',
            type: 'line',
            stack: '总量',
            itemStyle: {
              normal: {
                lineStyle: {
                  color: '#B0FFA8'
                }
              }
            },
            data: [320, 332, 301, 334, 390, 330, 320]
          }
        ]
      })
      window.addEventListener('resize', function () {
        myChart.resize()
      })
    }
  }
}
</script>

<style lang="stylus">
.electricity-statistics
  .el-input
    width auto
    margin-right 10px
  .el-input__inner
    border 1px solid #07f
    color #728ba1
    background none !important
  .el-button--primary
    margin-left 30px
    padding 12px 30px !important
  .demonstration
    display inline-block
    width 50px
    margin-left 10px
    text-align center
    color: #bbd4e9;
  .spr-line
    display: inline-block;
    width: 12px;
    text-align: center;
    background: #07f;
    height: 1px;
    line-height: 40px;
    vertical-align: middle;
    margin-right: 10px;
  .el-dialog__body .el-button--primary
    margin-left 0 !important
</style>
